import React from "react";
import LegalDocument from "../../components/legal/LegalDocument";
import { useCurrency } from "../../context/CurrencyContext";

export default function PrivacyPolicy() {
  const { settings } = useCurrency();
  return (
    <LegalDocument
      eyebrow="Legal"
      title="Privacy Policy"
      text={settings?.legal_privacy_policy}
      loading={!settings?.legal_privacy_policy}
      relatedLinks={[
        { to: "/legal/terms/renter", label: "Renter Terms & Conditions" },
        { to: "/legal/terms/host", label: "Host Terms & Conditions" },
      ]}
    />
  );
}
